import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom';
import SellerNavigationComponent from '../EcomSellerDashboard/Components/SellerNavigationComponent';
const baseUrl = process.env.REACT_APP_BASEURL;

const AddProperties = () => {
    const [metadescription2, setMetadescription2] = useState("");
    const [metatitle2, setMetatitle2] = useState("");
    const [atltext2, setAtltext2] = useState("");
    const [image, setImage] = useState(null); // Change the state to hold a File object
    const { id } = useParams();
    const navigate=useNavigate();
    const handleAddProperties=async()=>{
        const formData = new FormData();
        formData.append("image", image); 
       
        formData.append("alt", atltext2); 
        formData.append("metaTitle", metatitle2); 
        formData.append("metaDescription", metadescription2); 
        try {
          const response = await axios.post(
            `${baseUrl}/api/Ecomproduct/items/${id}/properties`,
            formData, 
            {
              headers: {
                "Content-Type": "multipart/form-data",
                // Authorization: `Bearer ${adminAuth?.token}`,
              },
            }
          );
          // Handle the response as needed
          console.log("Image upload success", response);
          navigate(`/productimageedit/${id}`)
        //   fetchProductData();
        //   setImage3("");
        //   setMetadescription3("");
        //   setMetatitle3("");
        //   setAtltext3("")
        } catch (error) {
          console.error("Failed to upload image", error);
        }
      }
  return (
    <div>
          <div style={{ display: "flex" }}>

                <SellerNavigationComponent />
<div>

        <tbody>
            <tr>
              {/* <td>
                <img
                  src={productData.properties[1].image[0]}
                  style={{ height: "100px", width: "100px" }}
                  className="ecomproductdetailslimagediv"
                />
              </td> */}
              <td>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <input
                    className="alttext"
                    id="atltext1"
                    placeholder="Enter alttext"
                    value={atltext2}
                    onChange={(event) => setAtltext2(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metatitle"
                    placeholder="Enter Metatitle"
                    value={metatitle2}
                    onChange={(event) => setMetatitle2(event.target.value)}
                  />
                  <input
                    className="alttext"
                    id="metadescription"
                    placeholder="Enter Metadescription"
                    value={metadescription2}
                    onChange={(event) => setMetadescription2(event.target.value)}
                  />
                  <input
                    type="file"
                    className="alttext"
                    placeholder="Enter image"
                    id="image"
                    name="image"
                    onChange={(event) => setImage(event.target.files[0])} // Update the image state
                  />
                  <button className="alttext" onClick={handleAddProperties}>
                   Add
                  </button>
                </div>
              </td>
              {/* <td><button onClick={()=>{handleClickdelete(1)}}>Delete</button></td> */}

            </tr>
          </tbody>
</div>
          </div>
    </div>
  )
}

export default AddProperties
